var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#043017;}\n\t.st1{fill:#157241;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#34935F;}\n\t.st4{fill:#07542A;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,266.9 80.7,228.7 80.7,266.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "471.3,266.9 390.5,228.7 390.5,266.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.4,0.5l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V58.6C32,26.5,57.5,0.5,89,0.5 H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,166.4H336.3c-31.5,0-59.9-28.9-59.9-61V0.5L439.4,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.7,218.3L169.7,218.3c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0 c0-5.7,4.6-10.4,10.4-10.4h60.7C165.1,207.9,169.7,212.6,169.7,218.3z M251.2,176.8L251.2,176.8c0,5.7-4.6,10.4-10.4,10.4H98.6 c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,166.5,251.2,171.1,251.2,176.8z M251.2,135.3L251.2,135.3 c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,125,251.2,129.6,251.2,135.3z  M251.2,93.8L251.2,93.8c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2 C246.6,83.4,251.2,88.1,251.2,93.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 266.9,
    className: "st4",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M152.7,301.1c18.4,0,32.2,10.3,36.6,27.1h-20.7c-3.2-6.6-9-9.9-16.2-9.9c-11.5,0-19.5,8.6-19.5,22.2 c0,13.6,7.9,22.2,19.5,22.2c7.2,0,13-3.3,16.2-9.9h20.7c-4.4,16.7-18.3,27-36.6,27c-22.8,0-38.8-16.2-38.8-39.3 C113.9,317.4,129.9,301.1,152.7,301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M228.8,380c-16.6,0-29.6-8.2-30.1-23.9h20c0.5,5.9,4.3,8.8,9.6,8.8c5.5,0,9-2.8,9-7.3 c0-14.3-38.6-6.6-38.4-34c0-14.6,12-22.8,28.2-22.8c16.8,0,28.2,8.4,28.9,23.1h-20.4c-0.3-4.9-3.8-7.9-8.9-8 c-4.5-0.1-7.9,2.2-7.9,7c0,13.4,38.2,7.4,38.2,33.2C257,369.2,246.9,380,228.8,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.1,302H341l-27.4,77.2h-23.5L262.7,302h20l19.1,58.3L321.1,302z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcCsv);
export default __webpack_public_path__ + "static/media/ac_csv.fbce1c0da000070b437c87ecb6329759.svg";
export { ForwardRef as ReactComponent };